import { render } from "./IconSquareDoutone.vue?vue&type=template&id=2e735856"
const script = {}

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__